
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Cliente } from '@/__env/lib/Clientes';
    import { Wait } from '@/__env/ext';
import { Envio } from '@/__env/lib/Ventas/Envios';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get EdicionPedido() { return this.Controlador.EdicionPedido; }
        public get Envio() { return this.Controlador.EdicionPedido.Envio; }
        public get IniciadoPlataforma() { return this.Controlador.EdicionPedido.IniciadoPlataforma; }
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        Estado: 'ok' | 'cargando' | 'error' = 'cargando';
        @Watch( 'Estado' )
        onEstado()
        {
            this.$emit( 'estado', this.Estado );

        }

        public HayCambios: boolean = false;
        async mounted()
        {
            while ( document.getElementById( 'row-form-envio' ) == null )
            {
                await Wait( 200 );
            }

            for ( let inpu of document.getElementById( 'row-form-envio' ).getElementsByTagName( 'input' ) )
            {
                inpu.addEventListener( 'input', ( event: any ) => { this.HayCambios = true; } );
            }

            this.Iniciar();
        }

        async Iniciar()
        {
            this.Estado = 'cargando';

            await Wait( 100 );

            this.Estado = 'ok';
            this.HayCambios = false;

            this.$nextTick( () =>
            {
                //document.getElementById( 'primer-input' ).getElementsByTagName( 'input' )[0].focus();
            } );
        }

        async Guardar()
        {
            this.Estado = 'cargando';
            let e = await this.Envio.save();
            if ( e )
            {
                this.Estado = 'ok';
                this.EdicionPedido.Envio = this.Envio;
                this.Controlador.Vista.Modo = 'resumen';
                this.$EventBus.Notificaciones.Completado( 'Guardado correctamente' );
            }
            else
            {
                this.Estado = 'ok';
                this.$EventBus.Notificaciones.Error( 'Error al guardar' );
            }
        }

        async Cancelar()
        {
            //this.Iniciar();
            this.Controlador.Vista.Modo = 'resumen';
        }


    }
